<template>
  <b-modal
    id="gamification-requested-demo"
    hide-header-close
    centered
    size="sm"
    title="You have requested for a demo!"
    header-class="text-primary text-center"
    body-class="px-5"
    footer-class="px-5">
    <p class="text-center">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
    <template slot="modal-footer">
      <b-button pill block variant="primary" @click="$root.$emit('bv::hide::modal', 'gamification-requested-demo')">Done</b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "GamificationDemoRequested"
}
</script>

<style lang="scss">
#gamification-requested-demo {
  .modal-dialog {
    max-width: 403px;
    margin-left: auto;
    margin-right: auto;
  }
  .modal-title::after {
    display: none;
  }
}
</style>
